
const dateformatTime = val => {
  if (!val) {
    return '-'
  }
  let time = val.replace(/^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/, '$4:$5')
  // 获取年月日
  let time2 = val.replace(/^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/, '$1-$2-$3')
  let formatTime = time2.replace(/-/g, '/')

  // let Year = new Date().getFullYear()
  // let Month = new Date().getMonth() + 1
  // let Day = new Date().getDate()
  // let oneDayTime = 24 * 60 * 60 * 1000
  // // 当前的时间戳
  // let nowTime = new Date(`${Year}/${Month}/${Day}`).getTime()
  // let preTime = new Date(formatTime).getTime() // 预估时间的时间戳
  let m = new Date(formatTime).getMonth() + 1
  let d = new Date(formatTime).getDate()

  /** 不显示今天 明天，显示具体日期 2024-10 【JDLX-2408-00499】 */
  // if (preTime === nowTime) {
  //   return `今天${time}`
  // }
  // if (preTime - nowTime === oneDayTime) {
  //   return `明天${time}`
  // }
  // if (preTime - nowTime === 2 * oneDayTime) {
  //   return `后天${time}`
  // }
  return `${m}月${d}日${time}`
}

const promiseDateFormatter = val => {
  if (!val) {
    return
  }
  const unitTimeStamp = 24 * 60 * 60 * 1000
  let timeDate = new Date(val.replace(/^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1/$2/$3')).getTime()
  let nowDate = new Date(`${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()}`).getTime()
  if (timeDate - nowDate <= unitTimeStamp) {
    return '次日'
  }
  if (timeDate - nowDate === 2 * unitTimeStamp) {
    return '后日'
  }
  if (timeDate - nowDate === 3 * unitTimeStamp) {
    return '大后日'
  }
  return `${new Date(timeDate).getMonth() + 1}月${new Date(timeDate).getDate()}日`
}
export default {
  dateformatTime,
  promiseDateFormatter
}
